import { render, staticRenderFns } from "./FAlert.vue?vue&type=template&id=67797a0a&scoped=true&"
import script from "./FAlert.vue?vue&type=script&lang=js&"
export * from "./FAlert.vue?vue&type=script&lang=js&"
import style0 from "./FAlert.vue?vue&type=style&index=0&id=67797a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67797a0a",
  null
  
)

export default component.exports